import type { VNode } from "vue";
import Vue, { h } from "vue";

export const BmGridCellRendererWrapper = Vue.extend({
  name: "BmGridCellRendererWrapper",
  render(): VNode | undefined {
    const params = (this as any).params;

    // If we're an aggregated cell, attempt to render the aggregated value
    if (!params.data && params.node.group) {
      const colId = params.colDef.colId;
      const aggregatedValue = params.node.aggData?.[colId];

      if (aggregatedValue === undefined) {
        return undefined;
      }

      // We could render DataCellBoolean here, but the old grouped grid
      // doesn't render anything.
      if (typeof aggregatedValue === "boolean") {
        return undefined;
      }

      let formattedValue = params.context.value.formatter(aggregatedValue);

      if (params.context.value.rendererMetadata.suffixExtractor) {
        const items = params.context.items;

        if (!items.length) {
          return;
        }

        const suffix = params.context.value.rendererMetadata.suffixExtractor(
          params.context.items[0]
        );

        formattedValue = `${formattedValue} ${suffix}`;
      }

      return h("div", formattedValue);
    }

    return (this as any).params.context.value.renderer(
      h,
      params.context.value.extractAndFormat(params.data),
      params.data,
      params.context.value
    );
  },
});
